import Layout from '@/components/business/Layout'

export default [
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录',
      keepAlive: false,
      requiresAuth: false,
    },
    component: () => import('../views/Login/index.vue'),
  },
  {
    path: '/car-scoring/task-list',
    name: 'CarScoringTaskList',
    meta: {
      title: '查询链接',
      showTitle: true,
      keepAlive: false,
      requiresAuth: false,
    },
    component: () => import('../views/CarScoring/TaskList.vue'),
  },
  {
    path: '',
    component: Layout,
    meta: {
      keepAlive: true,
      requiresAuth: true,
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: '首页',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Home/Home.vue'),
      },
      {
        path: '/statistics/analysis',
        name: 'StatisticsAnalysis',
        meta: {
          title: '统计分析',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/statistics/index.vue'),
      },

      {
        path: '/statistics/customer-analysis',
        name: 'CustomerAnalysis',
        meta: {
          title: '客户分析',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/statistics/companyindex.vue'),
      },
      {
        path: '/rapidQuotation',
        name: 'RapidQuotation',
        meta: {
          title: '快速报价',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/RapidQuotation/new/index.vue'),
      },
      {
        path: '/rapidQuotation/new',
        name: 'RapidQuotationNew',
        meta: {
          title: '快速报价',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/RapidQuotation/new/index.vue'),
      },
      {
        path: '/rapidQuotation/secondStep',
        name: 'SecondStep',
        redirect: '/rapidQuotation/new',
        meta: {
          title: '快速报价',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/RapidQuotation/new/index.vue'),
      },
      {
        path: '/rapidQuotation/thirdStep',
        name: 'ThirdStep',
        redirect: '/rapidQuotation/new',
        // meta: {
        //   title: '快速报价第三步',
        //   keepAlive: false,
        //   requiresAuth: true,
        // },
        // component: () => import('../views/RapidQuotation/ThirdStep.vue'),
      },
      {
        path: '/rapidQuotation/priceResult',
        name: 'priceResult',
        meta: {
          title: '报价结果',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/RapidQuotation/PriceResult.vue'),
      },
      {
        path: '/rapidQuotation/PriceSheet',
        name: 'PriceSheet',
        meta: {
          title: '报价单',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/RapidQuotation/PriceSheet.vue'),
      },
      {
        path: '/quotationRecord',
        name: 'QuotationRecord',
        meta: {
          title: '报价记录',
          keepAlive: true,
          requiresAuth: true,
        },
        component: () => import('../views/QuotationRecord/List.vue'),
      },
      {
        path: '/messageSettings',
        name: 'MessageSettings',
        meta: {
          title: '信息设置',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/MessageSettings/List.vue'),
      },
      {
        path: '/messages',
        name: 'Messages',
        meta: {
          title: '消息管理',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Messages/List.vue'),
      },
      {
        path: '/messageSettings/addRules',
        name: 'AddRules',
        meta: {
          title: '新增规则',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/MessageSettings/AddRules.vue'),
      },
      {
        path: '/user-manage/list',
        name: 'UserManageList',
        meta: {
          title: '用户管理',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/UserManage/List.vue'),
      },
      {
        path: '/user-manage/update/:id?',
        name: 'UserManageUpdate',
        meta: {
          title: '用户编辑',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/UserManage/Update.vue'),
      },
      {
        path: '/business-manager/list',
        name: 'BusinessManagerList',
        meta: {
          title: '业务经理',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/BusinessManager/List.vue'),
      },
      {
        path: '/business-manager/update/:id?',
        name: 'BusinessManagerUpdate',
        meta: {
          title: '业务经理编辑',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/BusinessManager/Update.vue'),
      },
      {
        path: '/insurance/vehicle/infoimport',
        name: 'InsuranceVehicleInfoImport',
        meta: {
          title: '保单信息导入',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/Vehicle/InfoImport.vue'),
      },
      {
        path: '/insurance/vehicle/list',
        name: 'InsuranceVehicleList',
        meta: {
          title: '保单信息查询',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/Vehicle/List.vue'),
      },
      {
        path: '/insurance/NonAutoPolicy/infoimport',
        name: 'InsuranceNonAutoPolicyInfoImport',
        meta: {
          title: '保单信息导入',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/NonAutoPolicy/InfoImport.vue'),
      },
      {
        path: '/insurance/NonAutoPolicy/List',
        name: 'InsuranceNonAutoPolicyList',
        meta: {
          title: '保单信息查询',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/NonAutoPolicy/List.vue'),
      },
      {
        path: '/insurance/driveLicense/list',
        name: 'InsuranceDrivrLicenseList',
        meta: {
          title: '行驶证信息查询',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/driveLicense/List.vue'),
      },
      {
        path: '/insurance/driveLicense/infoimport',
        name: 'InsuranceDrivrLicenseImport',
        meta: {
          title: '行驶证信息导入',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/driveLicense/InfoImport.vue'),
      },
      {
        path: '/insurance/vehicle/accident/:id',
        name: 'InsuranceVehicleAccident',
        meta: {
          title: '保单事故查询',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/Vehicle/Accident.vue'),
      },
      {
        path: '/insurance/vehicle/reporting/:id',
        name: 'InsuranceVehicleReporting',
        meta: {
          title: '保单报停查询',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/Vehicle/Reporting.vue'),
      },
      {
        path: '/insurance/invoice/detail/:id',
        name: 'InsuranceInvoiceDetail',
        meta: {
          title: '发票情况',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/Insurance/Invoice/Detail.vue'),
      },
      {
        path: '/poster-upload',
        name: 'PosterUpload',
        meta: {
          title: '海报上传',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/PosterUpload/index.vue'),
      },
      {
        path: '/scoring-legend',
        name: 'ScoringLegend',
        meta: {
          title: '图例',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/ScoringLegend/index.vue'),
      },
      {
        path: '/car-scoring/list',
        name: 'CarScoringList',
        meta: {
          title: '评分列表',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/CarScoring/List.vue'),
      },
      {
        path: '/car-scoring/info',
        name: 'CarScoringInfo',
        meta: {
          title: '评分详情',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/CarScoring/Info.vue'),
      },
      {
        path: '/car-scoring/compare',
        name: 'CarScoringCompare',
        meta: {
          title: '评分比较',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/CarScoring/Compare.vue'),
      },
      {
        path: '/car-scoring/guide',
        name: 'CarScoringGuide',
        meta: {
          title: '评分指南',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/CarScoring/Guide.vue'),
      },
      {
        path: '/non-vehicle-insurance/config',
        name: 'non-vehicle-insurance-config',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/config.vue'),
      },
      {
        path: '/non-vehicle-insurance/quotation',
        name: 'non-vehicle-insurance-quotation',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/quotation.vue'),
      },
      {
        path: '/non-vehicle-insurance/result',
        name: 'non-vehicle-insurance-result',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/result.vue'),
      },
      {
        path: '/non-vehicle-insurance/index',
        name: 'non-vehicle-insurance-index',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/rule/index.vue'),
      },
      {
        path: '/nonVehicleConfig',
        name: 'nonVehicleConfig',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/rule/nonVehicleConfig.vue'),
      },
      {
        path: '/non-vehicle-insurance/create-quotation-record',
        name: 'nonVehicleCreateQuotationRecord',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/quotation/create.vue'),
      },
      {
        path: '/non-vehicle-insurance/quotation-record',
        name: 'nonVehicleQuotationRecord',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/quotation/QuotationRecordList.vue'),
      },
      {
        path: '/non-vehicle-insurance/quotation-detail',
        name: 'nonVehicleQuotationDetail',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/non-vehicle-insurance/quotation/Detail.vue'),
      },
      {
        path: '/my/points',
        name: 'my-points',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/my/points.vue'),
      },
      {
        path: '/inventory/insurance',
        name: 'inventory/insurance',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/inventory/insurance.vue'),
      },
      {
        path: '/inventory/cases',
        name: 'inventory/cases',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/inventory/cases.vue'),
      },
      {
        path: '/inventory/parking',
        name: 'inventory/parking',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/inventory/parking.vue'),
      },
      {
        path: '/inventory/tracking',
        name: 'inventory/tracking',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/inventory/tracking.vue'),
      },
      {
        path: '/register-user/list',
        name: 'register-user/list',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/register-user/list.vue'),
      },
      {
        path: '/my/payment-history/list',
        name: 'my/payment-history/list',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/my/payment-history/list.vue'),
      },
      {
        path: '/quotation-comparison/edit',
        name: 'quotation-comparison/edit',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/edit.vue'),
      },
      {
        path: '/quotation-comparison/info/:id',
        name: 'quotation-comparison/info',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/info.vue'),
      },
      {
        path: '/quotation-comparison/list',
        name: 'quotation-comparison/list',
        meta: {
          keepAlive: true,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/list.vue'),
      },
      {
        path: '/quotation-comparison/netfee',
        name: 'quotation-comparison/netfee',
        meta: {
          title: '快速净费',
          keepAlive: true,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/NetFeeList.vue'),
      },
      {
        path: '/quotation-comparison/netfee-info',
        name: 'quotation-comparison/netfee-info',
        meta: {
          title: '快速净费详情',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/NetFeeInfo.vue'),
      },
      {
        path: '/netFeeRecord/secondStep',
        name: 'SecondStep',
        meta: {
          title: '快速净费编辑',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/NetFeeRecord/new/index.vue'),
      },

      {
        path: '/netFeeRecord/netfee',
        name: 'netFeeRecord/netfee',
        meta: {
          title: '快速净费记录',
          keepAlive: true,
          requiresAuth: true,
        },
        component: () => import('../views/NetFeeRecord/List.vue'),
      },
      {
        path: '/NetFeeRecord/priceResult',
        name: 'priceResult',
        meta: {
          title: '净费结果',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/NetFeeRecord/PriceResult.vue'),
      },

      {
        path: '/quotation-comparison/edit-ratio',
        name: 'quotation-comparison/edit-ratio',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/quotation-comparison/edit-ratio.vue'),
      },
      {
        path: '/normal-quotation/edit',
        name: 'normal-quotation/edit',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/normal-quotation/edit.vue'),
      },
      {
        path: '/normal-quotation/list',
        name: 'normal-quotation/list',
        meta: {
          keepAlive: true,
          requiresAuth: true,
        },
        component: () => import('../views/normal-quotation/list.vue'),
      },
      {
        path: '/normal-quotation/info/:id',
        name: 'normal-quotation/info',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/normal-quotation/info.vue'),
      },
      {
        path: '/normal-quotation/quoted',
        name: 'normal-quotation/quoted',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/normal-quotation/quoted.vue'),
      },
      {
        path: '/normal-quotation/pending',
        name: 'normal-quotation/pending',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/normal-quotation/pending.vue'),
      },
      {
        path: '/company/list',
        name: 'companyList',
        meta: {
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/company/list.vue'),
      },
      {
        path: '/company/edit/:id?',
        name: 'companyInfo',
        meta: {
          title: '公司信息编辑',
          keepAlive: false,
          requiresAuth: true,
        },
        component: () => import('../views/company/edit.vue'),
      },
    ],
  },
]
